import $ from "jquery";

// Sticky header
// document.addEventListener("DOMContentLoaded", function () {
//     function handleScroll() {
//       if (window.innerWidth >= 1200) {
//         const body = document.getElementById("body");
//         if (body) {
//           if (window.scrollY > 50) {
//             body.classList.add("fixed");
//           } else {
//             body.classList.remove("fixed");
//           }
//         }
//       }
//     }
  
//     function checkWindowSize() {
//       if (window.innerWidth >= 1200) {
//         window.addEventListener("scroll", handleScroll);
//       } else {
//         window.removeEventListener("scroll", handleScroll);
//       }
//     }
  
//     checkWindowSize();
//     window.addEventListener("resize", checkWindowSize);
//   });
  
// Sticky header END

// progress bar
window.onscroll = function() {myFunction()};

function myFunction() {
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var scrolled = (winScroll / height) * 100;
  document.getElementById("myBar").style.width = scrolled + "%";
} 

// progress button
$(document).ready(function () {
    "use strict";

    var progressPath, pathLength;

    function initProgressBar() {
        if ($(window).width() >= 1200) {
            if (!$('.progress-wrap path').length) return;

            progressPath = document.querySelector('.progress-wrap path');
            pathLength = progressPath.getTotalLength();

            progressPath.style.transition = 'none';
            progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
            progressPath.style.strokeDashoffset = pathLength;
            progressPath.getBoundingClientRect();
            progressPath.style.transition = 'stroke-dashoffset 10ms linear';

            var updateProgress = function () {
                var scroll = $(window).scrollTop();
                var height = $(document).height() - $(window).height();
                var progress = pathLength - (scroll * pathLength / height);
                progressPath.style.strokeDashoffset = progress;
            };

            updateProgress();
            $(window).off('scroll', updateProgress).on('scroll', updateProgress);

            var offset = 50;
            var duration = 550;

            $(window).off('scroll.progress').on('scroll.progress', function () {
                if ($(this).scrollTop() > offset) {
                    $('.progress-wrap').addClass('active-progress');
                } else {
                    $('.progress-wrap').removeClass('active-progress');
                }
            });

            $('.progress-wrap').off('click').on('click', function (event) {
                event.preventDefault();
                $('html, body').animate({ scrollTop: 0 }, duration);
                return false;
            });

        } else {
            $(window).off('scroll.progress');
            $('.progress-wrap').removeClass('active-progress');

            if (progressPath) {
                progressPath.style.strokeDashoffset = pathLength; 
            }
        }
    }

    initProgressBar();

    $(window).on('resize', function () {
        initProgressBar();
    });
});

$(document).ready(function(){

    $(".mag-summary a").on('click', function(event) {
 
      if (this.hash !== "") {
        event.preventDefault();
        var hash = this.hash;
        var targetOffset = $(hash).offset().top - 100; // Offset von 100px

        $('html, body').animate({
          scrollTop: targetOffset
        }, 800, function(){
          history.replaceState(null, null, hash); // Ändert die URL ohne zu springen
        });
      } 
    });
});
